import { Flex, Text } from '@chakra-ui/react';
import UnsubscribeIcon from '@/assets/icons/unsubscribe/Unsubscribe';

export const UnSubscribe = () => {
  return (
    <Flex
      flexDir="column"
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <UnsubscribeIcon width="200px" />
      <Text fontWeight="semiBold" fontSize="30px">
        You've been unsubscribed.
      </Text>
    </Flex>
  );
};

export default UnSubscribe;
